export const SITE = {
  brand: "iza3nee Creations",
  brandShort: "iza3nee",
  location: "Centreville, Virginia",
  email: "Iza3neecreations@gmail.com",
  tagline: "Custom Apparel & DTF Printing — Centreville, VA",
  hero: {
    eyebrow: "Centreville, VA · Est. by Hand",
    line1: "CUSTOM APPAREL",
    line2: "DTF PRINTING",
    sub: "Spirit wear, statement tees, and one-of-one custom drops — pressed with precision in Centreville, Virginia.",
  },
  social: {
    instagram: "https://www.instagram.com/iza3neecreations/",
    tiktok: "https://www.tiktok.com/@iza3nee.creations",
    etsy: "https://www.etsy.com/shop/iza3neecreations",
  },
  media: {
    heroBg:
      "https://static.prod-images.emergentagent.com/jobs/dfdd6f83-8736-4fe5-9b23-df5ab8814ce1/images/8a50047bc2b22501ad51a9161570a66c9ffe672b01e68f5a9f4617c22ea9362e.png",
    about:
      "https://static.prod-images.emergentagent.com/jobs/dfdd6f83-8736-4fe5-9b23-df5ab8814ce1/images/0099a6f069a9dd4a54371d1cdb0bcf8044924fbe6cf15b8518f96f3b84c73460.png",
  },
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_iza3nee-launch/artifacts/bj3s4xcc_il_794xN.1799006868_h75a.jpg",
      title: "Wife of the Party",
      tag: "Bridal / Bachelorette",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_iza3nee-launch/artifacts/g4loids2_il_794xN.1846472161_duu7.jpg",
      title: "Wifey",
      tag: "Couples / Bridal",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_iza3nee-launch/artifacts/k99vkden_il_794xN.1799008826_kxbs.jpg",
      title: "Love, Faith & a Little Science",
      tag: "Statement Tee",
    },
  ],
  nav: [
    { id: "about", label: "About" },
    { id: "gallery", label: "Gallery" },
    { id: "shop", label: "Shop" },
    { id: "contact", label: "Contact" },
  ],
};
